import { Avatar, Button, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { LeftArrowWhite, PurpleAlert } from 'Images';
import { useNavigate } from 'react-router-dom';
import { GetRenewPrescriptionUrl } from 'Utils';

interface IOrderRegularMedicationsProps {
  isNoValidrMedications: boolean;
}

export const OrderRegularMedications = (
  props: IOrderRegularMedicationsProps
) => {
  const isDesktop = useIsDesktop();
  const dictionary = Dictionary[DICTIONARY.MedicationsAndPrescriptionsLobby];
  const navigate = useNavigate();

  const { isNoValidrMedications } = props;

  return (
    <Stack
      direction={isDesktop ? 'row' : 'column'}
      alignItems='center'
      justifyContent='space-between'
      sx={{
        border: '1px solid',
        borderColor: 'primary.shade_200',
        bgcolor: '#fff',
        borderRadius: '12px',
        p: isDesktop ? '24px' : '14px',
        mt: isDesktop ? '32px' : '16px',
      }}
    >
      <Stack
        direction='row'
        alignItems={isDesktop ? 'center' : 'top'}
        maxWidth={isDesktop ? undefined : '100%'}
        alignSelf={isDesktop ? undefined : 'flex-start'}
      >
        <Avatar
          sx={{ height: '24px', width: '24px', mr: isDesktop ? '8px' : '4px' }}
          src={PurpleAlert}
          alt=''
        />
        <Typography component='h2' variant='body2'>
          {isNoValidrMedications
            ? dictionary.canAskForPrescription
            : dictionary.canAskForNewPrescription}
        </Typography>
      </Stack>

      <Button
        sx={
          isDesktop
            ? {
                p: 0,
                boxSizing: 'border-box',
                width: '280px',
                height: '46px',
                fontSize: '18px',
              }
            : {
                width: '186px',
                height: '36px',
                fontSize: '16px',
                alignSelf: 'flex-end',
                mt: '20px',
              }
        }
        variant='contained'
        endIcon={
          <Avatar
            src={LeftArrowWhite}
            alt=''
            sx={
              isDesktop
                ? { height: '20px', width: '20px' }
                : { height: '16px', width: '16px' }
            }
          />
        }
        onClick={() => navigate(GetRenewPrescriptionUrl())}
      >
        <Typography fontSize='18px' lineHeight='24px' fontWeight='400'>
          {isNoValidrMedications
            ? dictionary.askForPrescription
            : dictionary.requestNewMedication}
        </Typography>
      </Button>
    </Stack>
  );
};
